module.exports = __webpack_public_path__ + "img/icon-stockpicker-generating-done@2x.9c493210.png";